<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import BsLoader from "../../../../components/Loader/BsLoader.svelte";
	import { convert } from "../../../../services/helpers";
	import { loadingStatus, vehicleEditData } from "../../../../store/store";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let handleStatusChange;
	export let handleDelete;
	export let idStatus;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle Asset Owner</th>
				<th>Created On</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, name, created_at, status }}
				<tr>
					<td>
						<p>
							<span>
								{name}
							</span>
						</p>
					</td>
					<td>
						{convert(created_at)}
					</td>

					<td>
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p class="status-bar status-bar-1">Active</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							{#if status}
								<!-- This endpoint needs presetTaskId not returned by fetch api -->
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
							<DropdownItem on:click={() => handleDelete(id)}
								>Delete</DropdownItem
							>
							<DropdownItem
								on:click={() => {
									vehicleEditData.set({
										id: id,
										name: name,
										status: status,
									});
									navigate(
										`/master-data/vehicle-data/vehicle-asset-owner/edit/${id}`
									);
								}}>Edit</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.length} />
</LoaderContainer>
